import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            expenses: [],
            currentPage: '',
            pages: {}
        };
    },
    mutations: {
        setExpenses(state, data) {
            state.expenses = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        setCurrentPage(state, data) {
            state.currentPage = data;
        },
        clearStore(state) {
            state.expenses = [];
            state.pages = {};
        }
    },
    actions: {
        async createInstallerDebtsExpenses({ state, commit }, expenses) {
            try {
                return await api.post('/expenses/', expenses);
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/expense/?' + qs.stringify(params)).then(response => {
                    commit('setExpenses', response.data.data);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        async getExpense({ state, commit }, expenseId) {
            try {
                const response = await api.get('/expense/' + expenseId);
                return { ...response.data.data };
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async createExpense({ state, commit }, expense) {
            try {
                const response = await api.post('/expense/', { ...expense });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async updateExpense({ state, commit }, expense) {
            try {
                const response = await api.put('/expense/' + expense.id, { ...expense });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async updateDealExpenses({ state, commit }, params) {
            try {
                const response = await api.post('/expense/update-deal-expenses/', { ...params });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async createPayrollInfoExpenses({ state, commit }, params) {
            try {
                const response = await api.post('/expense/create-payroll-info-expenses/', { ...params });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async getDealsProduction({ state, commit }, params) {
            try {
                const response = await api.post(`/deals/expenses-production/?${qs.stringify(params)}`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getFactorySum({ state, commit }, params) {
            try {
                const response = await api.post(`/expenses/factory-sum/?${qs.stringify(params)}`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async createDealProductionExpenses({ state, commit }, expenses) {
            try {
                return await api.post('/expenses-production/', expenses);
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async getProductionExpensesAll({ state, commit }, params) {
            try {
                const response = await api.post(`/expenses/production-expenses-all/?${qs.stringify(params)}`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getEmployerExpensesByPeriod({ state, commit }, params) {
            try {
                const response = await api.post(`/expenses/get-employer-expenses-by-period/?${qs.stringify(params)}`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        }
    }
};

export default store;
